import { useMutation, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { propertyServices } from '../services/property.service';

export const useUpdateApprovalStatus = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ propertyId, approvalStatus, rejectionReason }) =>
      propertyServices.updateApprovalStatus({ propertyId, approvalStatus, rejectionReason }),
    onMutate: async ({ propertyId, approvalStatus, rejectionReason }) => {
      await queryClient.cancelQueries({ queryKey: ['properties'] });

      const previousData = queryClient.getQueriesData({ queryKey: ['properties'] });

      queryClient.setQueriesData({ queryKey: ['properties'] }, (old) => {
        if (!old) return old;

        return {
          ...old,
          data: old.data.map((property) =>
            property._id === propertyId
              ? { ...property, approvalStatus, rejectionReason: rejectionReason || property.rejectionReason }
              : property
          ),
        };
      });

      return { previousData };
    },
    onError: (error, variables, context) => {
      if (context?.previousData) {
        context.previousData.forEach(([queryKey, data]) => {
          queryClient.setQueryData(queryKey, data);
        });
      }
      toast.error(error.response?.data?.message || 'Failed to update approval status');
    },
    onSuccess: (data, variables) => {
      const message =
        variables.approvalStatus === 'approved'
          ? 'Property approved successfully'
          : 'Property rejected successfully';
      toast.success(message);
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ['properties'] });
    },
  });
};
